import React, { Component } from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';

import classes from './Admin.module.css';
import Select from '../../components/UI/Select/Select_controlled';
import Button from '../../components/UI/Buttons/Button';
import Dropzone from '../Dropzone/Dropzone';
import * as actions from '../../store/actions/index';

class Admin extends Component {

    componentDidMount () {
        this.props.onGetFireYears(this.props.geoserverUrl);
        this.props.onGetVersions();
    }

    changedActiveVersion(table, newVersionID){
        const variableName = "selectedVersion_" + table;
        this.props.onUpdateAdminSimpleVariable(variableName, newVersionID);
    }

    addNewVerion(table) {
        let text = "Θα προστεθεί νέα version στις πυρκαγιές με τη χρήση του αρχείου " + this.props.uploadedItem.name;
        if (table === "clc") text = "Θα προστεθεί νέα version στο Corine Land Cover με τη χρήση του αρχείου " + this.props.uploadedItem.name;

        Swal.fire({
            title: 'Είστε σίγουρος?',
            text: text,
            icon: 'warning',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ναι',
            cancelButtonText: 'Όχι',
            allowOutsideClick: false,
            preConfirm: () => {
                const user = JSON.parse(localStorage.getItem('user'));
                let token = null;
                if (user){
                    token = user.token;
                }

                const mapLayerProperties = this.props.mapLayers.filter(x => x.tableName === table)[0].layerProperties;
                const mandatoryFields = Object.keys(mapLayerProperties);

                const postData = {
                    jwt: token,
                    table: table,
                    mandatoryFields: mandatoryFields,
                    name: this.props.uploadedItem.name,
                    geojsonKeys: this.props.uploadedItem.geojsonKeys,
                    folder: this.props.uploadedItem.folder
                }

                this.props.onCreateNewVersion(postData);
            }
        }).then((result) => {            
            if (result.value) {
                Swal.fire({
                    title: '<div>' +
                                '<div style="display:flex; align-items:center; justify-content:center; width:2.67em; height:2.67em; margin: 0.66em auto 1em; border: .133em solid #94bf86; border-radius: 50%;">' +
                                    '<div style="box-sizing: border-box; width: 1.5em; height: 1.5em; -webkit-animation: swal2-rotate-loading 1.5s linear 0s infinite normal; animation: swal2-rotate-loading 1.5s linear 0s infinite normal; border: .133em solid transparent; border-radius: 100%; border-left-color: #545454; border-right-color: #545454;"></div>' +
                                '</div>' +
                                '<strong>Ανάλυση.</strong>' +
                            '</div>',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    text: 'Γίνεται ανάλυση και αποθήκευση του αρχείου. Παρακαλώ περιμένετε.',
                    
                }).then(() => {
                    if (this.props.newVersionUploaded){
                        Swal.fire(
                            'Ολοκλήρωση!',
                            'Δημιουργήθηκε νέα version.',
                            'success'
                        )
                        this.props.onGetVersions();

                    } else {
                        const mapLayerProperties = this.props.mapLayers.filter(x => x.tableName === table)[0].layerProperties;
                        const mandatoryFields = Object.keys(mapLayerProperties);

                        Swal.fire(
                            'Δεν βρέθηκαν ένα ή περισσότερα απαραίτητα πεδία!',
                            'Απαραίτητα πεδία: ' + mandatoryFields.join(", "),
                            'error'
                        )

                        this.props.onRemoveDirectoryFromUploads(this.props.uploadedItem.folder);
                    }

                    this.props.onClearVersion();
                    this.props.onClearFilesList();
                    const dropzone = document.getElementById("Dropzone");
                    dropzone.getElementsByTagName('input')[0].value = "";
                })
            }
        })
    }

    changeDatabaseVersion() {
        let text = "Θα γίνει αλλαγή της version για ";
        let andText = "";
        let newFiresVersionID = null;
        let newClcVersionID = null;

        if (this.props.savedVersion_fires !== this.props.selectedVersion_fires ){
            text = text + "τις πυρκαγιές";
            andText = " και για ";
            newFiresVersionID = this.props.selectedVersion_fires;
        }

        if (this.props.savedVersion_clc !== this.props.selectedVersion_clc){
            text = text + andText + "το Corine Land Cover";
            newClcVersionID = this.props.selectedVersion_clc;
        }

        Swal.fire({
            title: 'Είστε σίγουρος?',
            text: text,
            icon: 'warning',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ναι',
            cancelButtonText: 'Όχι',
            allowOutsideClick: false,
            preConfirm: () => {
                const postData = {
                    newFiresVersionID: newFiresVersionID,
                    newClcVersionID: newClcVersionID,
                    savedFiresVersionID: this.props.savedVersion_fires,
                    savedClcVersionID: this.props.savedVersion_clc
                }

                this.props.onChangeDatabaseVersion(postData);
            }
        }).then((result) => {            
            if (result.value) {
                Swal.fire({
                    title: '<div>' +
                                '<div style="display:flex; align-items:center; justify-content:center; width:2.67em; height:2.67em; margin: 0.66em auto 1em; border: .133em solid #94bf86; border-radius: 50%;">' +
                                    '<div style="box-sizing: border-box; width: 1.5em; height: 1.5em; -webkit-animation: swal2-rotate-loading 1.5s linear 0s infinite normal; animation: swal2-rotate-loading 1.5s linear 0s infinite normal; border: .133em solid transparent; border-radius: 100%; border-left-color: #545454; border-right-color: #545454;"></div>' +
                                '</div>' +
                                '<strong>Ανάλυση.</strong>' +
                            '</div>',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    text: 'Γίνεται αλλαγή της version. Παρακαλώ περιμένετε.',
                    
                }).then(() => {
                    Swal.fire(
                        'Ολοκλήρωση!',
                        'Έγινε αλλαγή της version.',
                        'success'
                    )
                    this.props.onGetVersions();
                    this.props.onUpdateAdminSimpleVariable("changedVersion", false);
                })
            }
        })
    }
    
    render () {
        if (this.props.newVersionAnalysed){
            Swal.close();
        }
        if (this.props.changedVersion){
            Swal.close();
        }
        
        return(
            <div className={classes.AdminWrapper}>
                <Dropzone />
                <div className={classes.versionsWrapper}>
                    <div className={classes.Flexbox}>
                        <h4 className={classes.Flex170}>Επίπεδο</h4>
                        <h4 className={classes.Flex150}>Active version</h4>
                    </div>
                    <div className={classes.Flexbox}>
                        <span className={classes.Flex170}>Fires</span>
                        <Select 
                            classes={classes.SelectWrapper}
                            options={this.props.versions.fires}
                            value={this.props.selectedVersion_fires}
                            changed={(e) => this.changedActiveVersion("fires",e.target.value)}
                        />
                        <div className={classes.PaddingWrapper}>
                            <Button clicked={() => this.addNewVerion("fires")} disabled={!this.props.uploadedItem}>
                                <div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
                                    </div>
                                    <span>Νέα version</span>
                                </div>
                            </Button>
                        </div>
                    </div>
                    <div className={classes.Flexbox}>
                        <span className={classes.Flex170}>Corine Land Cover</span>
                        <Select 
                            classes={classes.SelectWrapper}
                            options={this.props.versions.clc}
                            value={this.props.selectedVersion_clc}
                            changed={(e) => this.changedActiveVersion("clc",e.target.value)}
                        />
                        <div className={classes.PaddingWrapper}>
                            <Button clicked={() => this.addNewVerion("clc")} disabled={!this.props.uploadedItem}>
                                <div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
                                    </div>
                                    <span>Νέα version</span>
                                </div>
                            </Button>
                        </div>
                    </div>
                </div>

                <div className={classes.ButtonWrapper}>
                    <Button 
                        disabled={this.props.savedVersion_clc === this.props.selectedVersion_clc && this.props.savedVersion_fires === this.props.selectedVersion_fires}
                        clicked={() => this.changeDatabaseVersion()}
                    >
                        <div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"></path></svg>
                            </div>
                            <span>Αποθήκευση</span>
                        </div>
                    </Button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        geoserverUrl: state.system.geoserverUrl,
        versions: state.admin.versions,
        selectedVersion_fires: state.admin.selectedVersion_fires,
        selectedVersion_clc: state.admin.selectedVersion_clc,
        savedVersion_fires: state.admin.savedVersion_fires,
        savedVersion_clc: state.admin.savedVersion_clc,
        uploadedItem: state.dropzone.uploadedItem,
        mapLayers: state.layerItems.mapLayers,
        newVersionAnalysed: state.admin.newVersionAnalysed,
        newVersionUploaded: state.admin.newVersionUploaded,
        changedVersion: state.admin.changedVersion
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onGetFireYears: (geoserverUrl) => dispatch(actions.getFireYears(geoserverUrl)),
        onGetVersions: () => dispatch(actions.getVersions()),
        onUpdateAdminSimpleVariable: (variableName, newValue) => dispatch(actions.updateAdminSimpleVariable(variableName, newValue)),
        onCreateNewVersion: (postData) => dispatch(actions.createNewVersion(postData)),
        onClearVersion: () => dispatch(actions.clearVersion()),
        onClearFilesList: () => dispatch(actions.clearFilesList()),
        onChangeDatabaseVersion: (postData) => dispatch(actions.changeDatabaseVersion(postData)),
        onRemoveDirectoryFromUploads: (folder) => dispatch(actions.removeDirectoryFromUploads(folder))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin);